import SDIcon from '../SDIcon'
import type { SDIconProps } from '../SDIcon'

const IconArrowUpRight = ({ size = 16, color = 'currentColor', ...props }: SDIconProps) => (
  <SDIcon viewBox='0 0 24 24' size={size} color={color} aria-hidden='true' {...props}>
    <g fill='none' stroke='currentColor' strokeWidth='1.9' strokeLinecap='round' strokeLinejoin='round'>
      <path d='M7 17 17 7' />
      <path d='M7 7h10v10' />
    </g>
  </SDIcon>
)

export default IconArrowUpRight
